import React, { ReactElement } from 'react'

import { clsx } from 'clsx'

import { ButtonClick, track } from '@dfds-frontend/tracking'

import { useTranslation } from '@/hooks/useDebugTranslations'

interface Props {
  returnLeg: boolean | undefined
  setShowDepartures: (show: boolean) => void
  showDepartures: boolean
}

const ViewHideDeparturesLink: React.FC<Props> = ({ returnLeg, setShowDepartures, showDepartures }): ReactElement => {
  const { t } = useTranslation()

  return (
    <div
      className={clsx(
        'bg-semantic-global-background-white py-semantic-global-lg text-semantic-global-primary-default flex flex-row items-center justify-center',
        !showDepartures && 'mb-semantic-global-md md:mb-semantic-global-lg',
        returnLeg
          ? showDepartures
            ? 'mb-semantic-global-md md:mb-semantic-global-lg'
            : 'mt-0'
          : 'mb-semantic-global-md md:mb-semantic-global-lg'
      )}
    >
      <button
        className="typography-body-md-medium cursor-pointer"
        onClick={() => {
          setShowDepartures(!showDepartures)
          track<ButtonClick>({
            clickedElementText: `${!showDepartures}`,
            event: 'buttonClick',
            eventAction: `view${!returnLeg ? 'Later' : 'Earlier'}Departures`,
          })
        }}
        type="button"
      >
        {showDepartures
          ? t(`HIDE-${!returnLeg ? 'LATER' : 'EARLIER'}-DEPARTURES`)
          : t(`VIEW-${!returnLeg ? 'LATER' : 'EARLIER'}-DEPARTURES`)}
      </button>
    </div>
  )
}

export default ViewHideDeparturesLink
